import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postAPI } from "../../services/api.service";
import { useDispatch } from "react-redux";
import { setShowTourModel } from "../../ReduxToolkit/Reducers/Layout/LayoutReducer";
import { useSelector } from "react-redux";

interface SignInData {
  email: string;
  password: string;
}

export const useSignIn = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const showTour = useSelector((state: any) => state.layout.showTourModel);
  // alert("showTour value in useSignIn hook: " + showTour);
const userId=JSON.parse(String(localStorage.getItem("user")))?.id;
const userRole=JSON.parse(String(localStorage.getItem("user")))?.role;

  dispatch(
    setShowTourModel((localStorage.getItem("app_tour_shown_v1") != "true")&&(userId!=undefined)&&(userRole!="admin"))
  );

  const handleSignIn = async (data: SignInData) => {
    setLoading(true);
    try {
      // alert("handleSignIn called")
      const response = await postAPI<{
        data: { token: string; user: any };
        message: string;
      }>("/auth/login", data);
      if (response.status === 200 && response.data) {
        toast.success("Login successful!");
        localStorage.setItem("user", JSON.stringify(response.data?.data?.user));
        localStorage.setItem("login", JSON.stringify(true));
        // navigate('/dashboard/default');
        navigate(`${process.env.PUBLIC_URL}/group/group_list`);
        // dispatch(setShowTourModel(false));
      } else {
        toast.error(
          String(response?.error || "Login failed. Please try again.")
        );
      }
    } catch (error) {
      toast.error("An error occurred during login.");
    } finally {
      setLoading(false);
    }
  };

  return { handleSignIn, loading };
};
